<template>
    <div class="container mx-auto py-8 lg:py-20">
        <div class="flex flex-col items-center justify-center gap-6 lg:flex-row lg:gap-20">
            <ReviewStats />
            <div class="flex w-full flex-col items-start gap-4 lg:w-1/2">
                <NuxtPage />
                <div class="flex w-full justify-center lg:justify-start">
                    <Pagination
                        :items-per-page="10"
                        v-bind="reviews()?.allReviews?.paginatorInfo"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
    import Pagination from '~/components/Pagination.vue'
    import ReviewStats from '~/components/Review/ReviewStats.vue'
    import { reviews } from '~/store/reviews'
    await reviews().fetchReviewStats()
    const route = useRoute()
    await reviews().fetchCustomerReviews(10, Number(route?.params?.page) || 1)
</script>
